import { networkStatus } from "@Src/constants";

const memberExportRequest = (state) => {
  state.csvExport.apiState.status = networkStatus.IN_PROGRESS;
};
const memberExportResponse = (state, action) => {
  state.csvExport.apiState.status = networkStatus.SUCCESS;
  state.csvExport.memberExport = action.payload.response;
};
const memberExportError = (state, action) => {
  state.csvExport.apiState.status = networkStatus.ERROR;
  state.csvExport.apiState.error = action.payload;
};
const checkExportStatusRequest = (state, action) => {
  state.csvExport.apiState.status = networkStatus.IN_PROGRESS;
};
const checkExportStatusResponse = (state, action) => {
  state.csvExport.apiState.status = networkStatus.SUCCESS;
  state.csvExport.memberExport = action.payload.response;
};
const memberExportDownloadRequest = (state, action) => {
  state.csvExport.apiState.status = networkStatus.IN_PROGRESS;
};
const memberExportDownloadResponse = (state, action) => {
  state.csvExport.apiState.status = networkStatus.SUCCESS;
  state.csvExport.exportedData = action.payload;
};

export default {
  memberExportRequest,
  memberExportResponse,
  memberExportError,
  checkExportStatusRequest,
  checkExportStatusResponse,
  memberExportDownloadRequest,
  memberExportDownloadResponse,
};
